<script>
export default {
	name: 'LeafletPane',
	inheritAttrs: false,
	props: {
		paneName: {
			type: String,
			required: true
		},
		zIndex: {
			type: Number,
			default: 650
		},
	},
	inject: [ 'leaflet', 'state' ],
	data() {
		return {
			pane: null,
			rendered: false
		};
	},
	provide() {
		return { pane: this.paneName, };
	},
	watch: {
		zIndex() {
			if (this.pane)
				this.pane.style.zIndex = this.zIndex;
		},
	},
	async created() {
		this.createPane();
	},
	beforeDestroy() {
		if (this.state.map) {
			if (this.pane) {
				this.leaflet.DomUtil.remove(this.pane);
			}
			this.rendered = false;
		}
	},
	methods: {
		/* expose pane for usage by children or etc */
		getPane() {
			return this.pane;
		},
		getPaneName() {
			return this.paneName;
		},
		createPane() {
			if (this.state.map && !this.pane) {
				this.pane = this.state.map.createPane(this.paneName);
				this.pane.style.zIndex = this.zIndex;
			}
		},
	},
	render(createElement) {
		if (this.state.map && !this.rendered) {
			if (!this.pane) {
				this.createPane();
			}
			this.rendered = true;
		}
		return this.$scopedSlots.default ? createElement('div', this.$scopedSlots.default({})) : null;
	}
};
</script>
